export const ActionTypes = {
  LOADING: "REMOVE_COLUMNS_LOADING",
  ERROR: "REMOVE_COLUMNS_ERROR",
  SUCCESS: "REMOVE_COLUMNS_SUCCESS",
};
